<header>
  <app-toolbar size="small">
    <div class="right">
      <app-button label="Add comment" (click)="dialog.set('new-comment')" size="small" />
    </div>
  </app-toolbar>
</header>

<section class="mt-1 comments" [class.is-mobile]="isMobile">
  @for (comment of issue().comments; track comment.id) {
    <div [class.important]="comment.importance === 'high'" class="comment" [title]="comment.importance === 'high' ? 'Important comment' : ''" tooltipPosition="top">
      <div class="flex">
        <div>
          <span class="created-by">{{ comment.createdByName }}</span> <span class="created">{{ comment.createdAt | date: 'dd/MM/yyyy HH:MM' }}</span
          >&nbsp;
          @if (!isMobile) {
            <span class="small"> {{ comment.createdAt | amTimeAgo }}</span
            >&nbsp;
          }
          @switch (comment.commentType) {
            @case ('fm') {
              <span class="author"><i class="mdi"></i> fm</span>&nbsp;
            }
            @case ('contractor') {
              <span class="author"><i class="mdi"></i> Contractor</span>&nbsp;
            }
            @case ('question') {
              <span class="author green"><i class="mdi mdi-comment-question-outline"></i> Question</span>&nbsp;
            }
            @case ('answer') {
              <span class="author green"><i class="mdi mdi-comment-arrow-left-outline"></i> Answer</span>&nbsp;
            }
          }
          @if (comment.createdBy === issue().createdBy) {
            <span class="author" title="The Author">author</span>&nbsp;
          }
          @if (comment.createdBy === issue().assignee) {
            <span class="author" title="The Assignee">assignee</span>&nbsp;
          }
        </div>
        <div class="flex-1 text-right">
          @if (comment.isMyComment) {
            <span class="dropdown"
              ><i class="mdi mdi-dots-vertical"></i>
              <div class="dropdown-content">
                <div class="can-hover" (click)="deleteComment(comment)">
                  <div><i class="mdi mdi-trash-can-outline"></i> Remove</div>
                  <div class="details">Remove your comment</div>
                </div>
              </div>
            </span>
          }
        </div>
      </div>
      <div class="comment-line">
        @if (comment.commentType === 'question') {
          <i class="mdi mdi-comment-question-outline" title="This is a question" tooltipPosition="top"></i>
        }
        @if (comment.commentType === 'answer') {
          <i class="mdi mdi-comment-arrow-left-outline" title="This is an answer" tooltipPosition="top"></i>
        }
        {{ comment.comment }}
      </div>
    </div>
  }
</section>
@switch (dialog()) {
  @case ('new-comment') {
    <app-dialog header="Add Comment" [dimensions]="{ width: 600, height: isMobile ? 500 : 248 }" (onClose)="dialog.set(null)">
      <section [class.is-mobile]="isMobile">
        <textarea class="fourd" [(ngModel)]="comment" rows="6"></textarea>
        <div class="comment-actions">
          <div>
            <span>
              <app-chip [simple]="true" label="Normal" [isRadio]="true" [checked]="!isImportant()" (click)="setPriority(false)" [noBackground]="true" [noColour]="true" selectedBackgroundColour="#f0f0f0" />
              <app-chip [simple]="true" label="Important" [isRadio]="true" [checked]="isImportant()" (click)="setPriority(true)" [noBackground]="true" selectedBackgroundColour="#de0000" />
            </span>
          </div>
          <div>
            <select class="fourd" [(ngModel)]="commentType" name="commentType">
              <option [ngValue]="null">General comment</option>
              <option value="contractor">Contractor</option>
              <option value="fm">FM</option>
              <option value="4d">4D</option>
              <!-- <option value="Answer">Answer</option>
              <option value="question">Question</option> -->
            </select>
          </div>
          <div>
            <app-button (click)="addComment()" label="Add Comment" icon="mdi mdi-plus" />
          </div>
        </div>
      </section>
    </app-dialog>
  }
}
